<template>
  <form-main @back="makeSureBack">
    <template slot="nav">
      <div class="vita-form-nav">
        <p>
          上传附件资料
        </p>
      </div>
    </template>
    <template slot="main">
      <div class="vita-form-main">
        <div class="content">
          <template>
            <vue-scroll :ops="ops">
              <el-form label-width="80px" :model="formaDate"  ref="formTime">
                <div style="padding:0px 30px 0px 25px;">
                  <fieldset class="vita-form-fieldset" style="border: 1px solid white;padding: 10px"  >
                    <legend>报名信息</legend>
                    <!--                  <el-form :model="formaDate" label-width="80px">-->
                    <el-row>
                      <el-col :span="16">
                        <el-form-item label="报名名称" >
                          <el-input v-model.trim="formaDate.enroll_name"
                                    :disabled="true"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="注册协会" prop="org_id"
                        >
                          <el-select v-model="formaDate.org_id"
                                     clearable
                                     disabled
                                     filterable
                                     placeholder="请选择注册协会">
                            <el-option
                                    v-for="item in organList"
                                    :key="item.org_id"
                                    :label="item.org_abbreviation"
                                    :value="item.org_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-if="showIdentify && identity_list.length > 0">
                      <el-col :span="24">
                        <el-form-item label="主要身份" prop="identity_ids" :rules="[{required: showIdentify === 1,message:'请选择您当前的主要身份',trigger: 'change'}]" >
                          <el-select v-model="formaDate.identity_ids"
                                     style="width: 100%"
                                     multiple
                                     filterable
                                     clearable
                                     placeholder="请选择您当前的主要身份">
                            <el-option
                                    v-for="item in identity_list"
                                    :key="item.identity_id"
                                    :label="item.identity_name"
                                    :value="item.identity_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <!--                  </el-form>-->

                  </fieldset>
                </div>
                <div class="form-wrap">

                  <template v-if="monthsList.length && time_change_way ==='month'">
                    <template  v-if="is_choose_classDate">
                      <div class="upfile">
                        <fieldset class="vita-form-fieldset physical">
                          <legend>意向参加<span v-if="train_way.indexOf('offline') !== -1">线下</span>培训班月份选择</legend>
                          <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item label="第一志愿" prop="intention_class_date_one" :rules="[{required: is_choose_classDate == 1 ? true : false,message:'请填写第一志愿培训班月份',trigger: 'change'}]">
                                  <el-select  v-model="formaDate.intention_class_date_one" clearable placeholder="请选择第一志愿培训班月份" style="width:700px">
                                    <el-option
                                      v-for="item in selectForIntentionOne"
                                      :key="item.value"
                                      :label="item.label"
                                      :disabled="item.disabled || item.isTimeDisabled"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="第二志愿">
                                  <el-select  v-model="formaDate.intention_class_date_two" clearable placeholder="请选择第二志愿培训班月份" style="width:700px">
                                    <el-option
                                      v-for="item in selectForIntentionTwo"
                                      :key="item.value"
                                      :label="item.label"
                                      :disabled="item.disabled || item.isTimeDisabled"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                            </el-col>
                            <!--<el-col :span="12">-->
                              <!--<p v-if="enroll_type == 'common' && is_speediness_train === 0 && isShowTenderTips">-->
                                <!--您的最高等级获取时间为：<span class="red-color">{{ rank_date | timeFormat('yyyy-MM-DD') }}</span>；根据<a href="/uploads/import_tpl/中国足球协会教练员培训管理规定.pdf" target="_blank" style="color: #4cd964">《中国足球协会教练员培训管理规定》（2023年版）</a>，您只能选择：<span class="red-color">{{ rank_date | getAvaibleTimeStartForSign}}</span>&nbsp;以后的时间段；-->
                              <!--</p>-->
                            <!--</el-col>-->
                            <el-col :span="24">
                              <p class="red-color">
                                最终时间以录取通知为准，培训时间可能会根据具体情况进行调整，培训开始前将通过短信形式通知拟录取教练员。
                              </p>
                            </el-col>
                          </el-row>
                         
                        </fieldset>
                      </div>
                    </template>
                  </template>
                  <template v-if="monthsListPeriods.length && time_change_way ==='periods'">
                    <template  v-if="is_choose_classDate">
                      <div class="upfile">
                        <fieldset class="vita-form-fieldset physical">
                          <legend>意向参加<span v-if="train_way.indexOf('offline') !== -1">线下</span>培训班期数选择</legend>
                          <el-row :gutter="10">
                            <el-col :span="10">
                              <el-form-item label="第一志愿" prop="intention_class_periods_one" :rules="[{required: is_choose_classDate == 1 ? true : false,message:'请选择第一志愿培训班期数',trigger: 'change'}]">
                                <el-select  v-model="formaDate.intention_class_periods_one" clearable placeholder="请选择第一志愿培训班期数" style="width:700px">
                                  <el-option
                                    v-for="item in selectForIntentionOnePeriods"
                                    :key="item.value"
                                    :label="item.label"
                                    :disabled="item.disabled || item.isTimeDisabled"
                                    :value="item.value">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item label="第二志愿">
                                <el-select  v-model="formaDate.intention_class_periods_two" clearable placeholder="请选择第二志愿培训班期数" style="width:700px">
                                  <el-option
                                    v-for="item in selectForIntentionTwoPeriods"
                                    :key="item.value"
                                    :label="item.label"
                                    :disabled="item.disabled || item.isTimeDisabled"
                                    :value="item.value">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <!--<el-col :span="12">-->
                              <!--<p v-if="enroll_type == 'common' && is_speediness_train === 0 && isShowTenderTips">-->
                                <!--您的最高等级获取时间为：<span class="red-color">{{ rank_date | timeFormat('yyyy-MM-DD') }}</span>；根据<a href="/uploads/import_tpl/中国足球协会教练员培训管理规定.pdf" target="_blank" style="color: #4cd964">《中国足球协会教练员培训管理规定》（2023年版）</a>，您只能选择：<span class="red-color">{{ rank_date | getAvaibleTimeStartForSign}}</span>&nbsp;以后的时间段；-->
                              <!--</p>-->
                            <!--</el-col>-->
                            <el-col :span="24">
                              <p class="red-color">
                                最终时间以录取通知为准，培训时间可能会根据具体情况进行调整，培训开始前将通过短信形式通知拟录取教练员。
                              </p>
                            </el-col>
                          </el-row>
        
                        </fieldset>
                      </div>
                    </template>
                  </template>
                   <div class="upfile" v-if="showAddress">
                        <fieldset class="vita-form-fieldset physical">
                          <legend>现居住地</legend>
                          <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item label="省份" prop="province_id"
                                :rules="[showAddress == 1 ? requiredItem('省份', true) : '']"
                                >
                                  <el-select v-model="formaDate.province_id" placeholder="请选择省份" @change="updateCity">
                                    <el-option v-for="(item, index) in area_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                                  </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                              <p><span class="red-color" style="margin-right:5px;">*</span>将会参考现居住地为您就近安排培训班</p>
                            </el-col>
                          </el-row>
                          <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item label="市" prop="city_id"
                                :rules="[showAddress == 1 ? requiredItem('市', true) : '']"
                                >
                                  <el-select v-model="formaDate.city_id" placeholder="请选择市">
                                    <el-option v-for="(item, index) in city_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                                  </el-select>
                                </el-form-item>
                            </el-col>
                          </el-row>
                         
                        </fieldset>
                      </div>
  
                  <!-- <div class="upfile" v-if="is_choose_classDate">
                    <fieldset class="vita-form-fieldset physical">
                      <legend>意向参加培训班月份选择</legend>
                      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="color:#FFFFFF"><span style="color: red" v-if="is_choose_classDate === 1">*</span> 全选</el-checkbox>
                      <div style="margin: 15px 0;"></div>
                      <el-checkbox-group v-model="formaDate.checkedMonth" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="month in months" :label="month" :key="month" style="color:#FFFFFF">{{month}}</el-checkbox>
                      </el-checkbox-group>
                    </fieldset>
                  </div> -->
                  
                  <div class="upfile" v-if="showPhysicalTemplate">
                    <fieldset class="vita-form-fieldset physical">
                      <legend>个人体检报告电子版</legend>
                      <!--                    <el-form :model="formaDate" label-width="80px" ref="formTime">-->
                      <el-row :gutter="10">
                        <el-col :span="10">
                          <el-form-item label="体检时间" prop="medical_date" :rules="[{required:showPhysicalTemplate===1,validator: validateTime, trigger: 'change'}]">
                            <el-date-picker
                                    v-model="formaDate.medical_date"
                                    type="date"
                                    :picker-options="startTime"
                                    value-format="timestamp"
                                    placeholder="请选择体检时间">
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <p><span class="red-color">六个月内</span>二级甲等及以上医院或正规体检机构体检报告(报告检查内容须包括不限于:心电图，心脏彩超，血常规，肺功能，肝功能，肾功能，电解质，血压，血脂，血糖，甲状腺功能) ；</p>
                        </el-col>
                      </el-row>
                      <!--                    </el-form>-->
                      <div  class="fujian">
                        <p class="intro"><span style="color: red" v-if="showPhysicalTemplate === 1">*</span> 附件：</p>
                        <div class="uploadFujian" >
                          <el-upload
                                  ref="uploadFile"
                                  action="/api/enroll/upload_enroll_file.json"
                                  :file-list="fileList"
                                  :data="fileUpParam"
                                  :on-change="fileChange"
                                  :before-upload="beforeUpload"
                                  :on-success="uploadSuccess"
                                  :on-remove="fileRemove"
                                  :headers="fileUpHeaders"
                                  :disabled="physical_loading"
                                  :on-error="FileError"
                          >
                            <el-button type="primary" :loading="physical_loading">点击上传</el-button>

                            <div slot="tip" class>只能上传一个PDF文件，且文件大小不能超过20M</div>
                          </el-upload>
                          <el-button type="primary" class='watchFile ' v-show="fileList.length>0" ><a :href="url" target="_blank">查看文件</a></el-button>
                        </div>
                      </div>

                    </fieldset>
                  </div>
                  <div class="upfile" v-if="showAccidentTemplate">
                    <fieldset class="vita-form-fieldset accident">
                      <legend>人身意外保险电子版</legend>
                      <el-row :gutter="10">
                        <el-col :span="10">
                          <el-form-item label="有效期" prop="accident_end_date" :rules="[{required:showAccidentTemplate == 1,message: '请填写有效保险截至日期', trigger: 'change'}]">
                            <el-date-picker
                                    v-model="formaDate.accident_end_date"
                                    type="date"
                                    :picker-options="startTimeAccident"
                                    value-format="timestamp"
                                    placeholder="请选择保险截止日期">
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <p><span class="red-color">有效期内</span>的人身意外保险证明；</p>
                        </el-col>
                      </el-row>
                      <div  class="fujian">
                        <p class="intro"><span style="color: red" v-if="showAccidentTemplate === 1">*</span> 附件：</p>
                        <div class="uploadFujian">
                          <el-upload
                                  ref="uploadFile"
                                  action="/api/enroll/upload_enroll_file.json"
                                  :file-list="newfileList"
                                  :data="newfileUpParam"
                                  :headers="fileUpHeaders"
                                  :on-change="newfileChange"
                                  :before-upload="newbeforeUpload"
                                  :on-success="newuploadSuccess"
                                  :on-remove="newfileRemove"
                                  :disabled="accident_loading"
                                  :on-error="newFileError"
                          >
                            <el-button type="primary" :loading="accident_loading">点击上传</el-button>
                            <div slot="tip" class>只能上传一个PDF文件，且文件大小不能超过20M</div>
                          </el-upload>
                          <el-button type="primary" class='watchFile'  v-show="newfileList.length>0"><a :href="newurl" target="_blank" >查看文件</a></el-button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="upfile" v-if="showJobTemplate">
                    <fieldset class="vita-form-fieldset accident">
                      <legend>在职证明电子版</legend>
                      <div class="fujian">
                        <div class="intro flex-column">
                          <div><span style="color: red" v-if="showJobTemplate === 1">*</span>附件：</div>
                          <a href="/uploads/import_tpl/在职证明示例.pdf" target="_blank"><div class="tips">示例</div></a>
                        </div>
                        <div class="uploadFujian">
                          <el-upload
                                  ref="uploadFile"
                                  action="/api/enroll/upload_enroll_file.json"
                                  :file-list="templateList"
                                  :data="templateFileUpParam"
                                  :headers="fileUpHeaders"
                                  :before-upload="templateBeforeUpload"
                                  :on-success="templateUploadSuccess"
                                  :on-remove="templateFileRemove"
                                  :disabled="template_loading"
                                  :on-error="templateFileError"
                          >
                            <el-button type="primary" :loading="template_loading">点击上传</el-button>

                            <div slot="tip" class>请先<a href="/uploads/import_tpl/在职证明模板.docx" style="color: #4cd964" download>下载在职证明模板</a>填写后上传，只能上传一个加盖公章后的PDF文件，且文件大小不能超过20M</div>
                          </el-upload>
                          <el-button type="primary" class='watchFile'  v-show="templateList.length>0"><a :href="templateUrl" target="_blank" >查看文件</a></el-button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="upfile" v-if="showProofCrime">
                    <fieldset class="vita-form-fieldset accident">
                      <legend>无犯罪记录证明</legend>
                      <div class="fujian">
                        <p class="intro"><span style="color: red" v-if="showProofCrime === 1">*</span>附件：</p>
                        <div class="uploadFujian">
                          <el-upload
                            ref="uploadFile"
                            action="/api/enroll/upload_enroll_file.json"
                            :file-list="newfileListProof"
                            :data="templateFileUpParamProof"
                            :headers="fileUpHeaders"
                            :before-upload="templateBeforeUploadProof"
                            :on-success="templateUploadSuccessProof"
                            :on-remove="templateFileRemoveProof"
                            :disabled="template_loading_proof"
                            :on-error="templateFileErrorProof"
                          >
                            <el-button type="primary" :loading="template_loading_proof">点击上传</el-button>
                            <div slot="tip" class>只能上传一个PDF文件，且文件大小不能超过20M</div>
                          </el-upload>
                          <el-button type="primary" class='watchFile'  v-show="newfileListProof.length>0"><a :href="templateUrlProof" target="_blank" >查看文件</a></el-button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="upfile" v-if="showVaccine">
                    <fieldset class="vita-form-fieldset accident">
                      <legend>疫苗接种证明</legend>
                      <div class="fujian">
                        <p class="intro"><span style="color: red" v-if="showVaccine === 1">*</span>附件：</p>
                        <div class="uploadFujian">
                          <el-upload
                            ref="uploadFile"
                            action="/api/enroll/upload_enroll_file.json"
                            :file-list="newfileListVaccine"
                            :data="templateFileUpParamVaccine"
                            :headers="fileUpHeaders"
                            :before-upload="templateBeforeUploadVaccine"
                            :on-success="templateUploadSuccessVaccine"
                            :on-remove="templateFileRemoveVaccine"
                            :disabled="template_loading_Vaccine"
                            :on-error="templateFileErrorVaccine"
                          >
                            <el-button type="primary" :loading="template_loading_proof">点击上传</el-button>
                            <div slot="tip" class>只能上传一个jpg,jpeg,png,gif格式的图片，且文件大小不能超过20M</div>
                          </el-upload>
                          <el-button type="primary" class='watchFile'  v-show="newfileListVaccine.length>0"><a :href="templateUrlVaccine" target="_blank" >查看文件</a></el-button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="upfile" v-if="showEnglistResume">
                    <fieldset class="vita-form-fieldset accident">
                      <legend>中英文简历</legend>
                      <div class="fujian">
                        <div class="intro flex-column">
                          <div><span style="color: red" v-if="showEnglistResume === 1">*</span>附件：</div>
                          <!-- <a href="/uploads/import_tpl/英文简历模板.docx" target="_blank"><div class="tips">示例</div></a>                           -->
                        </div>
                        <div class="uploadFujian">
                          <el-upload
                            ref="uploadFile"
                            action="/api/enroll/upload_enroll_file.json"
                            :file-list="englishResume"
                            :data="templateFileUpParamResume"
                            :headers="fileUpHeaders"
                            :before-upload="templateBeforeUploadResume"
                            :on-success="templateUploadSuccessResume"
                            :on-remove="templateFileRemoveResume"
                            :disabled="template_loading_resume"
                            :on-error="templateFileErrorResume"
                          >
                            <el-button type="primary" :loading="template_loading_resume">点击上传</el-button>
                            <div slot="tip" class>支持jpg/png/pdf/xlsx/xls/docx/doc中英文简历文件，且文件大小不能超过20M，简历模板和内容均不设限制，学员根据个人风格制作。</div>
                          </el-upload>
                          <el-button type="primary" class='watchFile'  v-show="englishResume.length>0"><a :href="templateUrlEnglishResume" target="_blank" >查看文件</a></el-button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <!-- <div class="upfile" v-if="showNotification">
                    <fieldset class="vita-form-fieldset accident">
                      <legend>培训班管理规定告知书电子版</legend>
                      <div class="fujian">
                        <p class="intro"><span style="color: red" v-if="showNotification === 1">*</span>附件：</p>
                        <div class="uploadFujian">
                          <el-upload
                            ref="uploadFile"
                            action="/api/enroll/upload_enroll_file.json"
                            :file-list="newfileListNotification"
                            :data="templateFileUpParamNotification"
                            :headers="fileUpHeaders"
                            :before-upload="templateBeforeUploadNotification"
                            :on-success="templateUploadSuccessNotification"
                            :on-remove="templateFileRemoveNotification"
                            :disabled="template_loading_notification"
                            :on-error="templateFileErrorNotification"
                          >
                            <el-button type="primary" :loading="template_loading_notification">点击上传</el-button>
                            <div slot="tip" class>请先<a href="/uploads/import_tpl/中国足协教练员培训班管理规定告知书.docx" style="color: #4cd964" download>下载中国足协教练员培训班管理规定告知书</a>填写后上传，只能上传一个本人签名的告知书后的PDF文件，且文件大小不能超过20M</div>
                          </el-upload>
                          <el-button type="primary" class='watchFile'  v-show="newfileListNotification.length>0"><a :href="templateUrlNotification" target="_blank" >查看文件</a></el-button>
                        </div>
                      </div>
                    </fieldset>
                  </div> -->

                  <div class="upfile"  v-if="showNotification">
                       <fieldset class="vita-form-fieldset accident">
                      <legend>免责声明</legend>
                      <div class="fujian">
                        <div class="uploadFujian">
                          <span v-if="showNotification == 1" style="color: #f56c6c; margin-right: 3px;">*</span><span class="suc btn" @click="handleClick">请确认并同意《免责声明》</span>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div >
                    <p style="margin: 8px 0 ">
                      <el-checkbox v-model="checked" />
                      我已阅读并同意以下内容</p>
                    <p>1.我已阅读<a href="/uploads/import_tpl/中国足球协会教练员培训管理规定.pdf" target="_blank" style="color: #4cd964">《中国足球协会教练员培训管理规定》（2023年版）</a>，并了解其中关于教练员培训的相关要求。</p>
                    <p>2.本人承诺提交的全部信息和证明材料均真实、准确、有效，没有隐瞒或虚构任何事实，也没有买卖或造假等不诚信行为。</p>
                    <p>3.如本人违反以上承诺，我将承担由此产生的一切后果，愿意接受中国足协相应的处罚。</p>
                    <!--<p>4.我已阅读<a href="/uploads/import_tpl/中国足协教练员培训班管理规定告知书.pdf" target="_blank" style="color: #4cd964">《中国足协教练员培训班管理规定告知书》</a></p>-->
                  </div>
                </div>
              </el-form>
            </vue-scroll>
          </template>
        </div>
        <div class="btns">
          <el-button v-if="matriculate_status !== 'personnelPerfect'" type="primary" @click="makeSureCommit('next')" :disabled="accident_loading || physical_loading">暂时保存</el-button>
          <el-button type="primary" @click="makeSureCommit('commit',enroll_type)"  :disabled="accident_loading || physical_loading" v-if="['make_up_exam','teacher_train','physical_make_up_exam'].includes(enroll_type)">提交报名信息</el-button>
          <el-button type="primary" @click="makeSureCommit('commit')" :disabled="accident_loading || physical_loading" v-else>提交到注册协会</el-button>
          <el-button type="danger" @click="makeSureBack">取消</el-button>
        </div>
        <yioks-tips :showTips="submitTips" :tips="msg" @hideTips="hideCommitTips" :loading="loading"></yioks-tips>
        <yioks-tips :showTips="backTips" tips="确定放弃修改并返回吗？" @hideTips="hideBackTips"></yioks-tips>
<!--        <yioks-tips :showTips="backTips" tips="确定放弃修改并返回吗？" @hideTips="previousTips"></yioks-tips>-->
        <el-dialog
          title=""
          :visible.sync="isShowOntification"
          width="680px"
          :close-on-click-modal="false"
          :show-close="false"
          :top="'15vh'"
          custom-class="no-padding"
          :before-close="handleNotificationClose">
          <div class="word-wrapper">
            <vue-scroll :ops="opsGrey">
              <div class="wrod-content">
                <div class="word-box">
                  <word-info></word-info>
                </div>
              </div>
            </vue-scroll>
          </div>
          <div class="confrimBox">
              <el-button :type="isConfirmBtnAvaible ? 'primary' : 'info'" :disabled="!isConfirmBtnAvaible" @click="handleConfirmRead">我已经确认 <span v-if="timerCount <= 30 && timerCount > 0">({{timerCount}}s)</span></el-button>
            </div>
        </el-dialog>
      </div>
    </template>
  </form-main>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";

import { mapMutations } from "vuex";
import { storageData } from "@/assets/js/storage";
import { registration_report_view , personnel_enroll_two,organList,personnel_identity_data} from "@/api/ab_signup/api";
import { getAvaibleTimeStartForSign } from '@/assets/js/yioksFilters';
import { area_list } from "@/assets/js/region";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
export default {
  name: "vitaFile",
  data() {
    const validateTime = (rule, value, callback, bool, index) => {
      if(this.showPhysicalTemplate===1){
        if (value === null) {
          callback(new Error("请选择体检时间"));
        } else {
          const tmp = new  Date().getTime() - this.formaDate.medical_date;
          if (tmp > 1000 * 3600 * 24 * 365){
            callback(new Error("体检时间需在365天以内"));
          }else{
            callback()
          }
        }
      } else{
        callback()
      }
      if(this.is_choose_classDate===1){
        if (value === null) {
          callback(new Error("请选择意向培训班开班月份"));
        } else {
//          const tmp = new  Date().getTime() - this.formaDate.medical_date;
//          if (tmp > 1000 * 3600 * 24 * 180){
//            callback(new Error("体检时间需在180天以内"));
//          }else{
//            callback()
//          }
          callback()
        }
      } else{
        callback()
      }
    };
    const MAXCOUNT = 30;  // 30s
    return {
      ops: ops(),
      opsGrey: ops(true),
      validateTime,
      showJobTemplate:0,
      showPhysicalTemplate:0,
      is_choose_classDate:0,
      showAccidentTemplate:0,
      showProofCrime:0,
      showVaccine:0,
      showEnglistResume:0,
      showNotification:0,
      showAddress: 0,
      showIdentify:0,
      months: [],
      monthsList: [],
      monthsListPeriods: [],
      enroll_level:'',
      time_change_way:'',
      identity_ids:[],
      loading:false,
      checked:false,
      checkAll: false,
      isIndeterminate: true,
      fileList: [],
      identity_list:[],
      physical_loading:false,
      accident_loading:false,
      enroll_type:'',
      train_way:'',
      newfileList: [],
      newfileListProof: [],
      newfileListVaccine: [],
      englishResume: [],
      newfileListNotification: [],
      templateList:[],
      templateFileUpParam:{},
      templateFileUpParamProof:{},
      templateFileUpParamVaccine:{},
      templateFileUpParamResume:{},
      templateFileUpParamNotification:{},
      templateUrl:'',
      templateUrlProof:'',
      templateUrlVaccine:'',
      templateUrlEnglishResume:'',
      templateUrlNotification:'',
      template_loading:false,
      template_loading_proof:false,
      template_loading_resume:false,
      template_loading_Vaccine:false,
      template_loading_notification:false,
      fileUpParam: {},
      url:false,
      newurl:false,
      newfileUpParam: {},
      fileListTag: false,
      newfileListTag: false,
      organList:[],
      formaDate: {
        enroll_uuid: this.$route.query.signId,
        submit_status: "",
        report_list: [],
        enroll_name:'',
        org_id:'',
        medical_date:'',
        accident_end_date: '',
        // checkedMonth:[],
        identity_ids:[],
        intention_class_date_one: '',  // 志愿一
        intention_class_date_two: '',  // 志愿二
        intention_class_periods_one: '',  // 志愿一 期数
        intention_class_periods_two: '',  // 志愿二 期数

        province_id: '',
        city_id: '',
      },
      startTime: {
        // 2023.03.16修改 还限制六个月内
        disabledDate: time => {
          let dateStart = new Date();
          dateStart.setMonth(dateStart.getMonth() - 6);
            return (new Date(time).getTime() > new Date().getTime() || new Date(time).getTime() < dateStart.getTime());
          }
      },
      startTimeAccident: {
        disabledDate: time => {
            return (new Date(time).getTime() < new Date().getTime());
          }

      },
      msg: "",
      fileUpHeaders: {
        "X-Token": storageData.getToken(),
        "X-UserType": storageData.getUserType()
      },
      backTips: false,
      submitTips: false,
      rank_date: 0,
      is_speediness_train: 0,
      isShowOntification: false,    // 显示弹窗
      isConfirmBtnAvaible: false,   // 已读按钮可用
      isReadStatus: false,
      btnTimer: null,
      timerCount: 10,  // 10s
      isShowTenderTips: false,
      area_list,
      city_list: [],
      matriculate_status: '',
    };
  },

  filters: {
    getAvaibleTimeStartForSign,
  },
  created() {
    this.getOrganList();
    this.getInfo();
  },
  components: {
    "form-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "word-info": () => import("@/views/Registration/vita/NotificationWords"),
  },

  computed: {
    selectForIntentionOne() {
      const defaultList = this.monthsList;
      if(!this.formaDate.intention_class_date_two) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_date_two === item.value
          }
        })
      }
    },
    selectForIntentionTwo() {
      const defaultList = this.monthsList;
      if(!this.formaDate.intention_class_date_one) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_date_one === item.value
          }
        })
      }
    },
    selectForIntentionOnePeriods() {
      const defaultList = this.monthsListPeriods;
      if(!this.formaDate.intention_class_periods_two) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_periods_two === item.value
          }
        })
      }
    },
    selectForIntentionTwoPeriods() {
      const defaultList = this.monthsListPeriods;
      if(!this.formaDate.intention_class_periods_one) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_periods_one === item.value
          }
        })
      }
    },
  },
  methods: {
    ...mapMutations(["updateUserInfo", "updateUserImg"]),
    requiredItem,
    getInfo() {
      const momentJs = require('moment');
      registration_report_view({ enroll_uuid: this.$route.query.signId }).then(
        res => {
          let {org_id,enroll_name,medical_date, accident_end_date, identity_ids,intention_class_date, intention_class_date_one, intention_class_date_two, classPhase, rank_date, province_id, city_id, matriculate_status,intention_class_periods_one,intention_class_periods_two}=res.data.result.enrollMap;
          // if(intention_class_date){
          //   this.formaDate.checkedMonth = JSON.parse(intention_class_date);
          // }
          matriculate_status && (this.matriculate_status = matriculate_status)
          intention_class_date_one && (this.formaDate.intention_class_date_one = intention_class_date_one)
          intention_class_date_two && (this.formaDate.intention_class_date_two = intention_class_date_two)
          intention_class_periods_one && (this.formaDate.intention_class_periods_one = intention_class_periods_one)
          intention_class_periods_two && (this.formaDate.intention_class_periods_two = intention_class_periods_two)
          const {enroll_level,is_need_accident,is_need_jobProof,is_need_physical,is_choose_classDate,class_end,class_start,is_proof_crime,is_vaccine,is_notification,is_need_identity, is_speediness_train, is_need_live_address,is_need_English_resume, enroll_type,time_change_way}=res.data.result.enroll;
          try {
            const momentJs = require('moment');
            const avaibleTimeStand = momentJs(rank_date).add(13, 'M').format('x');
            const timeRes = Number(avaibleTimeStand) < class_start;
            if(timeRes) {
              this.isShowTenderTips = false;
            } else {
              this.isShowTenderTips = true;
            }
          } catch(err) {
            console.log('timeStamp formate function is error')
            this.isShowTenderTips = true;
          }
          
          this.enroll_level=enroll_level
          this.is_speediness_train = is_speediness_train;
          this.enroll_type = enroll_type;
          this.time_change_way = time_change_way;
//          if (enroll_level==='PRO'||enroll_level==='P'||enroll_level==='0'){
//            this.showJobTemplate=true;
//          }
          
          // 计划开班时间段 返回月份
          let class_starts = this.$yioks.time(class_start);
          let class_ends = this.$yioks.time(class_end);
          this.months = this.$yioks.getMonthBetween(class_starts,class_ends);
          this.monthsList = [];
          this.monthsListPeriods = [];
          rank_date && (this.rank_date = rank_date);
          if(classPhase.length && this.time_change_way === 'month') {
            classPhase.forEach(item => {
              const { start_date, end_date } = item;
              const momentJs = require('moment');
              let timeAvaible;   // true: 当前时间段可用； false 不可用
              if(is_speediness_train == 0 && rank_date && enroll_type == 'common') {
                // console.log('start check', momentJs(start_date).subtract(12, 'M').format('yyyy-MM'))
                // console.log('stand time', momentJs(rank_date).format('yyyy-MM'))
                // console.log('res',  momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M'))
                timeAvaible = momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M');
              } else {
                timeAvaible = true;
              }
              const tentionMonthList = {
                label: `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`,
                // value: JSON.stringify(item),
                value: `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`,
                meta: item,
                disabled: false,
                isTimeDisabled: !timeAvaible,
              }
              this.monthsList.push(tentionMonthList)
            })
          }
          if(classPhase.length && this.time_change_way === 'periods') {
            classPhase.forEach((item,index) => {
              const { start_date, end_date,start_date_two,end_date_two,province_name,city_name } = item;
              const momentJs = require('moment');
              let timeAvaible;   // true: 当前时间段可用； false 不可用
              if(is_speediness_train == 0 && rank_date && enroll_type == 'common') {
                // console.log('start check', momentJs(start_date).subtract(12, 'M').format('yyyy-MM'))
                // console.log('stand time', momentJs(rank_date).format('yyyy-MM'))
                // console.log('res',  momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M'))
                timeAvaible = momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M');
              } else {
                timeAvaible = true;
              }
  
              let lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM")}，阶段二：${momentJs(end_date).format("yyyy-MM")}`;
              let value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM")},${momentJs(end_date).format("yyyy-MM")}`;
  
              if(start_date_two){
                lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM-DD")} 至 ${momentJs(end_date).format("yyyy-MM-DD")}，阶段二：${momentJs(start_date_two).format("yyyy-MM-DD")} 至 ${momentJs(end_date_two).format("yyyy-MM-DD")}`;
    
                value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM-DD")}至${momentJs(end_date).format("yyyy-MM-DD")},${momentJs(start_date_two).format("yyyy-MM-DD")}至${momentJs(end_date_two).format("yyyy-MM-DD")}`;
                
              }
              if(province_name){
                lebelName = lebelName + "，" + province_name + city_name;
                value1 = value1 + "," + province_name + city_name;
              }
  
              lebelName = lebelName+'）';
              
              const tentionMonthList = {
                label: lebelName,
                // value: JSON.stringify(item),
                value: value1,
                meta: item,
                disabled: false,
                isTimeDisabled: !timeAvaible,
              }
              this.monthsListPeriods.push(tentionMonthList)
            })
          }
          this.showJobTemplate = is_need_jobProof;
          this.showPhysicalTemplate = is_need_physical;
          this.showProofCrime = is_proof_crime;
          this.showAddress = is_need_live_address;
          this.showVaccine = is_vaccine;
          this.showEnglistResume = is_need_English_resume;
          this.showNotification = is_notification;
          this.showIdentify = is_need_identity;
          this.is_choose_classDate = is_choose_classDate;
          this.showAccidentTemplate = is_need_accident;
          // identity_ids && (this.identity_ids=identity_ids);
          (medical_date && medical_date > 0) && (this.formaDate.medical_date=medical_date);
          (accident_end_date && accident_end_date >0)&& (this.formaDate.accident_end_date = accident_end_date)
          enroll_name && (this.formaDate.enroll_name=enroll_name);
          org_id && (this.formaDate.org_id=org_id);
          const result = res.data.result.report_list;
          this.enroll_type=res.data.result.enroll.enroll_type;
          this.train_way=res.data.result.enroll.train_way;
          if (result.length > 0) {
            for (let index = 0; index < result.length; index++) {
              const file = {};
              const {report_name,report_address,report_uuid,report_type} = result[index];
              file.name = report_name;
              file.report_url = report_address;
              file.report_uuid = report_uuid;
              file.report_type = report_type;
              if (result[index].report_type == "Physical") {
                this.fileList.push(file);
                this.url = report_address
              }else if (result[index].report_type == "jobProof") {
                this.templateList.push(file);
                this.templateUrl = report_address
              }else if (result[index].report_type == "notification") {
                this.newfileListNotification.push(file);
                this.templateUrlNotification = report_address
              }else if (result[index].report_type == "proofCrime") {
                this.newfileListProof.push(file);
                this.templateUrlProof = report_address
              }else if (result[index].report_type == "vaccine") {
                this.newfileListVaccine.push(file);
                this.templateUrlVaccine = report_address
              } else if(result[index].report_type == "EnglishResume") {
                this.englishResume.push(file);
                this.templateUrlEnglishResume = report_address
              } else {
                this.newurl=report_address;
                this.newfileList.push(file);
              }
            }
          }
          if (identity_ids){
            this.formaDate.identity_ids=identity_ids.split(',').map((item,index)=>{
              return Number(item)
            })
          }
          if (res.data.result.enroll.enroll_type==='common'){
            this.get_identity_data(res.data.result.enroll.enroll_level)
          }
          // 设置现居住地
          // province_id, city_id
          if(province_id) {
            if(province_id) province_id = String(province_id);
            if(city_id) city_id = String(city_id);
            this.city_list = this.$yioks.updateCity(String(province_id), this.area_list);
            this.$set(this.formaDate, 'province_id', province_id);
            this.$set(this.formaDate, 'city_id', city_id);
          }
        }
      ).catch(err=>{
        console.log(err)
      });
    },
    handleCheckAllChange(val) {
      this.formaDate.checkedMonth = val ? this.months : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.months.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.months.length;
    },
    get_identity_data(level){
      personnel_identity_data({
        level:level
      }).then(res=>{
        if (res.data.status===0){
          const { list }=res.data.result;
          if (list.length > 0){
            this.identity_list=list;
          }
        }
      })
    },
    getOrganList(){
      organList({}).then(
              ({ data: { result, status } }) => {
                if (status === 0) {
                  this.organList = result.list;
                }
              }
      );
    },
    makeSureBack() {
      this.backTips = true;
    },
    makeSureCommit(submit,type) {
      if(submit ==='commit'){
        // if(this.is_choose_classDate === 1){
          // if(this.formaDate.checkedMonth.length === 0){
          //   if(this.months.length > 0){
          //     this.$message.error("请至少选择一个意向培训班月份");
          //     return false;
          //   }
          // }
        // }
        
        let msg = "请确保已上传";
        let msgStatus = false;
        if(this.showPhysicalTemplate === 1){
          if (this.fileList.length === 0){
            msg += "个人体检报告、";
            msgStatus = true;
          }
        }
  
        if(this.showAccidentTemplate === 1){
          if (this.newfileList.length === 0){
            msg += "人身意外保险、";
            msgStatus = true;
          }
        }
        if(this.showProofCrime === 1){
          if (this.newfileListProof.length === 0){
            msg += "无犯罪记录证明、";
            msgStatus = true;
          }
        }
        if(this.showVaccine === 1){
          if (this.newfileListVaccine.length === 0){
            msg += "疫苗接种证明、";
            msgStatus = true;
          }
        }
        if(this.showEnglistResume === 1){
          if (this.englishResume.length === 0){
            msg += "英文简历、";
            msgStatus = true;
          }
        }
        if(this.showJobTemplate === 1){
          if (this.templateList.length === 0){
            msg += "在职证明、";
            msgStatus = true;
          }
        }
        if(msgStatus){
          msg = msg.substring(0,msg.length-1);
          this.$message.error(msg);
          return false;
        }
        if(this.showNotification === 1 && !this.isReadStatus){
            this.$message.error('请阅读并确认《免责声明》');
            return false;
        }
        // debugger
        // if(this.showAddress === 1) {

        // }

  
  
//        if (this.showJobTemplate) {
//          if (this.fileList.length === 0 || this.newfileList.length === 0 || this.templateList.length===0) {
//            this.$message.error("请确保已上传个人体检报告和人身意外保险以及在职证明");
//            return false;
//          }
//
//        }else{
//          if (this.fileList.length === 0 || this.newfileList.length === 0 ) {
//            this.$message.error("请确保已上传个人体检报告和人身意外保险");
//            return false;
//          }
//        }
        // if (this.fileList.length === 0 || this.newfileList.length === 0 || this.templateList.length===0) {
        //   this.$message.error("请确保已上传个人体检报告和人身意外保险以及在职证明");
        //   return false;
        // }
        this.$refs['formTime'].validate(valid => {
          if (valid) {
            
            this.msg= "确定提交到注册协会吗？";
            if(type === "make_up_exam" || type ==="teacher_train" || type === "physical_make_up_exam"){
              this.msg= "确定提交报名信息吗？";
            }
            
            
            this.formaDate.submit_status= "personnelSubmitted";
            if(type === "make_up_exam" || type === "physical_make_up_exam"){
              this.formaDate.submit_status ="examPersonnel";
            }else if(type === "teacher_train"){
              this.formaDate.submit_status ="teacherPersonnel";
            }
            if (this.checked){
              this.submitTips = true;
            } else{
              this.$message.error('请先选择同意相关内容后再次提交')
            }
          }else{
            this.$message.error('请完善所有带*号的必填项');
            return
          }
        })
      }
      else{
        this.msg ="确定暂时保存吗？" ;
        this.formaDate.submit_status= "personnelEdit"
        this.submitTips = true;
      }

    },
    hideBackTips(bool, flag) {
      if (flag) {
//        this.$router.push({path:'register_info',query:{uuid:this.$route.query.signId}});
        this.$router.go(-1);;
      }
      this.backTips = bool;
    },
    previousTips(bool, flag) {
      if (flag) {
        this.$router.go(-1);;
      }
      this.backTips = bool;
    },
    getDate() {
      this.loading = true;
      // 体检报告
      // if (this.fileListTag == false && this.fileList.length > 0) {
      //   // 没有上传新文件
      //   this.formaDate.report_list.push(this.fileList[0]);
      // } else if (this.fileListTag == true) {
      //   // 上传了新文件
      //   const file = {
      //     name: this.fileList[0].name,
      //     report_type: "Physical",
      //     report_url: this.fileList[0].report_url
      //   };
      //   this.formaDate.report_list.push(file);
      // }
      // // 人身意外保险
      // if (this.newfileListTag == false && this.newfileList.length > 0) {
      //   // 没有上传新文件
      //   this.formaDate.report_list.push(this.newfileList[0]);
      // } else if (this.newfileListTag == true) {
      //   // 上传了新文件
      //   const file = {
      //     name: this.newfileList[0].name,
      //     report_type: "Accident",
      //     report_url: this.newfileList[0].report_url
      //   };
      //   this.formaDate.report_list.push(file);
      // }
      this.commitData(this.formaDate);
    },
    commitData(formaDate){
      const file=[]
      if (this.showPhysicalTemplate){
        if (this.fileList.length>0){
          file.push(this.fileList[0])
        }
      }
  
      if (this.showAccidentTemplate){
        if(this.newfileList.length > 0){
          file.push(this.newfileList[0])
        }
      }
      if (this.showJobTemplate){
        if (this.templateList.length>0){
          file.push(this.templateList[0])
        }
      }
      if (this.showProofCrime){
        if (this.newfileListProof.length>0){
          file.push(this.newfileListProof[0])
        }
      }
      if (this.showVaccine){
        if (this.newfileListVaccine.length>0){
          file.push(this.newfileListVaccine[0])
        }
      }
      if (this.showNotification){
        if (this.newfileListNotification.length>0){
          file.push(this.newfileListNotification[0])
        }
      }
      if(this.showEnglistResume) {
        if(this.englishResume.length) {
          file.push(this.englishResume[0])
        }
      }
      personnel_enroll_two({
        enroll_uuid:formaDate.enroll_uuid,
        submit_status:formaDate.submit_status,
        report_list:JSON.stringify(file),
        // checkedMonth:JSON.stringify(formaDate.checkedMonth),
        medical_date:formaDate.medical_date,
        accident_end_date: formaDate.accident_end_date,
        // enroll_name:formaDate.enroll_name ,
        org_id:formaDate.org_id ,
        identity_ids:formaDate.identity_ids.join(','),
        intention_class_date_one: formaDate.intention_class_date_one,
        intention_class_date_two: formaDate.intention_class_date_two,
        intention_class_periods_one: formaDate.intention_class_periods_one,
        intention_class_periods_two: formaDate.intention_class_periods_two,
        province_id: formaDate.province_id,
        city_id: formaDate.city_id,
      }).then(res=>{
        this.loading = false;
        // 提交过后 把文件数组清空 避免文件重复
        this.formaDate.report_list=[];
        if (Number(res.data.status) === 0) {
          this.$message.success('资料保存成功')
//          this.$router.push({path:'register_info',query:{uuid:this.$route.query.signId}})
          this.$router.go(-1);;
        }else{
        this.$message.error(res.data.msg)
        }this.submitTips = false;
      }).catch(err=>{
        this.loading = false;
        this.submitTips=false;
        console.log(err)
      })
    },
    hideCommitTips(bool, flag) {
      if (flag) {
        this.getDate();
        return;
      }
      this.submitTips=bool;
    },
    fileChange(file, fileList) {

    },
    newfileChange(file, fileList) {

    },
    fileRemove(file, fileList) {
      // if (this.fileList.length){
      //   this.url=this.fileList[0].document_url
      // }
      // this.fileList = fileList.splice(-1);
       this.fileList = []
    },
    newfileRemove(file, fileList) {
     // if (this.newfileList.length){
     //   this.newurl=this.newfileList[0].response.result.document_url
     // }
     //  this.newfileList = fileList.splice(-1);
      this.newfileList = []

    },
    templateFileRemove(file,fileList){
      this.templateList = []
    },
    templateFileRemoveProof(file,fileList){
      this.newfileListProof = []
    },
    templateFileRemoveVaccine(file,fileList){
      this.newfileListVaccine = []
    },
    templateFileRemoveResume(file,fileList){
      this.englishResume = []
    },
    templateFileRemoveNotification(file,fileList){
      this.newfileListNotification = []
    },
    uploadSuccess(response, file, fileList) {
      if (response.status===0){
        if (fileList.length>0){
          this.fileList=[];
        }
        this.fileList.push({
          name: response.result.document_name,
          report_url: response.result.document_url,
          report_type: "Physical"
        });
        this.physical_loading=false;
        this.fileListTag = true;
        this.url=response.result.document_url;
      }else {
        fileList.splice(fileList.indexOf(file),1);
        this.physical_loading=false;
        this.$message.error(response.msg)
      }
    },
    newuploadSuccess(response, file, fileList) {
      if (response.status===0){
        if (fileList.length>0){
          this.newfileList=[];
        }
        this.newfileList.push({
          name: response.result.document_name,
          report_url: response.result.document_url,
          report_type: "Accident"
        });
        this.newfileListTag = true;
        this.accident_loading=false;
        this.newurl=response.result.document_url
      }else{
        fileList.splice(fileList.indexOf(file),1);
        this.$message.error(response.msg)
        this.accident_loading=false;
      }
    },
    templateUploadSuccess(response,file,fileList){
      if (response.status===0){
        if (fileList.length>0){
          this.templateList=[];
        }
        this.templateList.push({
          name: response.result.document_name,
          report_url: response.result.document_url,
          report_type: "jobProof"
        });
        this.templateUrl=response.result.document_url
        this.template_loading=false;
      }else{
        fileList.splice(fileList.indexOf(file),1);
        this.$message.error(response.msg)
        this.template_loading=false;
      }
    },
    templateUploadSuccessVaccine(response,file,fileList){
      if (response.status===0){
        if (fileList.length>0){
          this.newfileListVaccine=[];
        }
        this.newfileListVaccine.push({
          name: response.result.document_name,
          report_url: response.result.document_url,
          report_type: "vaccine"
        });
        this.templateUrlVaccine=response.result.document_url
        this.template_loading_Vaccine=false;
      }else{
        fileList.splice(fileList.indexOf(file),1);
        this.$message.error(response.msg)
        this.template_loading_Vaccine=false;
      }
    },
    templateUploadSuccessResume(response,file,fileList){
      if (response.status===0){
        if (fileList.length>0){
          this.englishResume=[];
        }
        this.englishResume.push({
          name: response.result.document_name,
          report_url: response.result.document_url,
          report_type: "EnglishResume"
        });
        this.templateUrlEnglishResume=response.result.document_url
        this.template_loading_resume=false;
      }else{
        fileList.splice(fileList.indexOf(file),1);
        this.$message.error(response.msg)
        this.template_loading_resume=false;
      }
    },
    templateUploadSuccessProof(response,file,fileList){
      if (response.status===0){
        if (fileList.length>0){
          this.newfileListProof=[];
        }
        this.newfileListProof.push({
          name: response.result.document_name,
          report_url: response.result.document_url,
          report_type: "proofCrime"
        });
        this.templateUrlProof=response.result.document_url
        this.template_loading_proof=false;
      }else{
        fileList.splice(fileList.indexOf(file),1);
        this.$message.error(response.msg)
        this.template_loading_proof=false;
      }
    },
    templateUploadSuccessNotification(response,file,fileList){
      if (response.status===0){
        if (fileList.length>0){
          this.newfileListNotification=[];
        }
        this.newfileListNotification.push({
          name: response.result.document_name,
          report_url: response.result.document_url,
          report_type: "notification"
        });
        this.templateUrlNotification=response.result.document_url
        this.template_loading_notification=false;
      }else{
        fileList.splice(fileList.indexOf(file),1);
        this.$message.error(response.msg)
        this.template_loading_notification=false;
      }
    },
    beforeUpload(file) {
      this.physical_loading=true;
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        this.fileList = [];
        this.physical_loading=false;
        return false;
      }
      if (!/^.*\.(pdf)$/i.test(file.name)) {
        this.$message.error("请上传PDF格式的文件!");
        this.fileList = [];
        this.physical_loading=false;
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.fileUpParam, key, param[key]);
        }
      }
    },
    newbeforeUpload(file) {
      this.accident_loading=true;
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        this.accident_loading=false;
        this.newfileList = [];
        return false;
      }
      if (!/^.*\.(pdf)$/i.test(file.name)) {
        this.$message.error("请上传PDF格式的文件!");
        this.accident_loading=false;
        this.newfileList = [];
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.newfileUpParam, key, param[key]);
        }
      }
    },
    templateBeforeUpload(file){
      this.template_loading=true;
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        this.template_loading=false;
        this.templateList = [];
        return false;
      }
      if (!/^.*\.(pdf)$/i.test(file.name)) {
        this.$message.error("请上传PDF格式的文件!");
        this.template_loading=false;
        this.templateList = [];
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.templateFileUpParam, key, param[key]);
        }
      }
    },
    templateBeforeUploadVaccine(file){
      this.template_loading_Vaccine=true;
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        this.template_loading_Vaccine=false;
        this.newfileListVaccine = [];
        return false;
      }
      if (!/^.*\.(jpg|png|jpeg|gif)$/i.test(file.name)) {
        this.$message.error("请上传jpg,jpeg,png,gif格式的图片!");
        this.template_loading_Vaccine=false;
        this.newfileListVaccine = [];
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.templateFileUpParamVaccine, key, param[key]);
        }
      }
    },
    templateBeforeUploadResume(file){
      this.template_loading_resume=true;
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        this.template_loading_resume=false;
        this.englishResume = [];
        return false;
      }
      if (!/^.*\.(jpg|png|jpeg|gif|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
        this.$message.error("请上传 jpg png jpeg gif pdf xlsx xls docx doc 格式的文件!");
        this.template_loading_resume=false;
        this.englishResume = [];
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.templateFileUpParamResume, key, param[key]);
        }
      }
    },
    templateBeforeUploadProof(file){
      this.template_loading_proof=true;
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        this.template_loading_proof=false;
        this.newfileListProof = [];
        return false;
      }
      if (!/^.*\.(pdf)$/i.test(file.name)) {
        this.$message.error("请上传PDF格式的文件!");
        this.template_loading_proof=false;
        this.newfileListProof = [];
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.templateFileUpParamProof, key, param[key]);
        }
      }
    },
    templateBeforeUploadNotification(file){
      this.template_loading_notification=true;
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error("文件大小不能超过20M!");
        this.template_loading_notification=false;
        this.newfileListNotification = [];
        return false;
      }
      if (!/^.*\.(pdf)$/i.test(file.name)) {
        this.$message.error("请上传PDF格式的文件!");
        this.template_loading_notification=false;
        this.newfileListNotification = [];
        return false;
      }
      let param = {
        document: file
      };
      for (const key in param) {
        if (param.hasOwnProperty(key)) {
          this.$set(this.templateFileUpParamNotification, key, param[key]);
        }
      }
    },
    FileError(err,file,fileList){
      this.$message.error('个人体检报告上传失败');
      this.physical_loading=false;
    },
    newFileError(err,file,fileList){
      this.$message.error('人身意外保险上传失败');
      this.accident_loading=false;
    },
    templateFileError(err,file,fileList){
      this.$message.error('在职证明上传失败');
      this.template_loading=false;
    },
    templateFileErrorProof(err,file,fileList){
      this.$message.error('无犯罪记录上传失败');
      this.template_loading_proof=false;
    },
    templateFileErrorVaccine(err,file,fileList){
      this.$message.error('疫苗接种证明上传失败');
      this.template_loading_vaccine=false;
    },
    templateFileErrorResume(err,file,fileList){
      this.$message.error('英文简历上传失败');
      this.template_loading_resume=false;
    },
    templateFileErrorNotification(err,file,fileList){
      this.$message.error('培训管理规定告知书上传失败');
      this.template_loading_notification=false;
    },
    changeTime(val){
      const tmp = new  Date().getTime() - this.formaDate.medical_date;
      if (tmp > 1000 * 3600 * 24 * 365){
        this.$message.error('体检时间需要在365天以内')
      }
    },
    handleClick() {
      const that = this;
      that.isShowOntification = true;
      if(that.btnTimer) {
        clearInterval(that.btnTimer)
        that.btnTimer = null;
      }
      if(!this.isConfirmBtnAvaible) {
        that.btnTimer = setInterval(() => {
          that.timerCount -= 1;
          if(!!!that.timerCount) {
            that.isConfirmBtnAvaible = true;
            clearInterval(that.btnTimer)
          }
        }, 1000)
      }
    },
    handleNotificationClose() {
      if(this.showNotification) {
        if(this.isReadStatus) {
          this.isShowOntification = false;
        } else {
          this.isShowOntification = true;
        }
      } else {
        this.isShowOntification = false;
      }
      
    },
    handleConfirmRead() {
      if(!this.isConfirmBtnAvaible) return
      this.isReadStatus = true; //
      this.isShowOntification = false;
    },
    // 身份变化
    updateCity(val) {
      if(val) {
        this.city_list = this.$yioks.updateCity(val, this.area_list)
        this.$set(this.formaDate, 'city_id', '')
      } else {
        this.city_list = []
      }
    },
  }
};
</script>


<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.vita-form-nav, .vita-form-main {
  flex: 1 1 auto;
  height: 100%;
}

.vita-form-nav {
  display: flex;
  align-items: center;

  p {
    font-size: $font_size_big;
  }
}

.vita-form-main {
  width: 100%;

  .content {
    height: calc(100% - 60px);
    padding: 20px 0;
    position: relative;
    background-color: $block_bg_color_base;
    .form-wrap {
      padding: 0 30px 0 25px;

      overflow hidden;
      .vita-form-fieldset {
        margin: 30px 0 30px 0;
        padding: 10px 10px 10px 10px;
        border: 1px solid $color_white;
        position :relative

        .must_accident,.must_physical{
          color $color_err
          position relative
          top 6px
          font-size 20px
        }
        .fujian{
          display flex
          .intro{
            width: 80px;
            text-align: center
          }
          .uploadFujian{
            width: calc(100% - 80px)
            position relative
          }
        }
        .watchFile{
          position absolute;
          left: 120px;
          top: 0
        }
      }

    }
  }

  .btns {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: $color_err; */
  }
}
.flex-column {
  flex-direction column
}
.tips {
  color $color_suc
  text-decoration underline
  cursor pointer
  user-select none
  position relative
}
.red-color {
  color $color_unusual !important
}
.suc {
  color $color_suc
}
.btn {
  cursor pointer
}

.confrimBox
  display flex
  align-items center
  justify-content center

.word-wrapper
  height 480px
  .word-content
    margin 0px 10px
</style>
<style lang="stylus">
.el-progress__text, .el-upload-list__item-name{
  color: #fff;
}
.vita-form-main
  .el-form-item__label {
    color: #fff;
  }

.no-padding
  .el-dialog__body
    padding  30px 10px
</style>
